import { render } from "./TableController.vue?vue&type=template&id=50d873de&scoped=true"
import script from "./TableController.vue?vue&type=script&lang=js"
export * from "./TableController.vue?vue&type=script&lang=js"

import "./TableController.vue?vue&type=style&index=0&id=50d873de&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d873de"]])

export default __exports__